import { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import BootstrapScreen from "../auth/BootstrapScreen";
import useAuthBootstrap from "../auth/useAuthBootstrap";
import { useTrainRecovery } from "../features/workoutLog/recovery/trainIdentity";

// Launch recovery (§9.8): a page load that started at `/` while the backend is
// unreachable goes to the TRAIN Hub once, which owns the recovery precedence.
function LaunchRecoveryRedirect({ consume }) {
  const navigate = useNavigate();
  useEffect(() => {
    if (consume()) navigate("/train", { replace: true });
  }, [consume, navigate]);
  return null;
}

// Blocks normal routing until the auth bootstrap resolves, exactly as AppRouter
// did before the router was mounted independently of it (Phase 8A, §9.8).
// `/train/*` is gated by ExecutionShellGate instead (Phase 8B).
export default function BootstrapGate() {
  const bootstrap = useAuthBootstrap();
  const location = useLocation();
  const navigate = useNavigate();
  const recovery = useTrainRecovery();
  const openLocalWorkout = bootstrap.status === "unavailable" &&
    Boolean(recovery?.hasOpenLocalWorkout);

  if (bootstrap.status === "resolving" || bootstrap.status === "unavailable") {
    return (
      <>
        {openLocalWorkout && recovery.launchedAtRoot && location.pathname === "/" ? (
          <LaunchRecoveryRedirect consume={recovery.consumeLaunchRedirect} />
        ) : null}
        <BootstrapScreen
          status={bootstrap.status}
          presentation={bootstrap.presentation}
          onRetry={bootstrap.retry}
          onReturnToWorkout={openLocalWorkout ? () => navigate("/train") : null}
        />
      </>
    );
  }

  return <Outlet />;
}
